import React from "react";
import { Arrow } from "./Arrow";
import { MaskedText } from "./MaskedText";

export function Hero({ profile, onViewWork }) {
  return (
    <section className="hero" id="home">
      <div className="hero__coordinates" data-hero-support data-depth="2" aria-hidden="true">
        37.7749 N / 122.4194 W
      </div>

      <div className="page-width hero__layout">
        <div className="hero__content">
          <div className="hero__kicker" data-hero-support data-depth="4">
            <span className="status-dot" />
            <span>{profile.availability}</span>
          </div>

          <h1 className="hero__title" aria-label={profile.name} data-depth="3">
            <MaskedText className="hero__title-line" data-hero-line>
              {profile.name}
            </MaskedText>
          </h1>

          <div className="hero__intro" data-hero-support data-depth="4">
            <p className="hero__role">
              {profile.role.map((line, index) => (
                <React.Fragment key={line}>
                  <span>{line}</span>
                  {index < profile.role.length - 1 ? " " : ""}
                </React.Fragment>
              ))}
            </p>
            <p className="hero__summary">{profile.introduction}</p>
            <button className="hero__cta" type="button" onClick={onViewWork}>
              View work <Arrow />
            </button>
          </div>
        </div>
      </div>

      <div className="hero__floor page-width" data-hero-support data-depth="2" aria-hidden="true">
        <span>Scroll to explore</span>
        <i />
        <span>Interface / Systems / Product</span>
      </div>
    </section>
  );
}
